import { render } from "./DeleteToolItem.vue?vue&type=template&id=3ebafb3c&scoped=true&ts=true&lang=pug"
import script from "./DeleteToolItem.vue?vue&type=script&lang=ts"
export * from "./DeleteToolItem.vue?vue&type=script&lang=ts"

import "./DeleteToolItem.vue?vue&type=style&index=0&id=3ebafb3c&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebafb3c"]])

export default __exports__